import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent, DialogWrapperComponent, UILayoutModule } from '@vdms-hq/ui';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { E2eIdDirective } from '@vdms-hq/shared';

@Component({
  selector: 'vdms-hq-mandatory-fields-info-dialog',
  standalone: true,
  imports: [CommonModule, DialogWrapperComponent, TranslateModule, UILayoutModule, ButtonComponent, E2eIdDirective],
  templateUrl: './mandatory-fields-info-dialog.component.html',
  styleUrls: ['./mandatory-fields-info-dialog.component.scss'],
})
export class MandatoryFieldsInfoDialogComponent {
  public data = inject(MAT_DIALOG_DATA);
  private ref: MatDialogRef<MandatoryFieldsInfoDialogComponent> = inject(MatDialogRef);

  close(dontShow: boolean) {
    this.ref.close(dontShow);
  }
}
